export enum WrapType {
  NotApplicable = 0,
  Wrap = 1,
  Unwrap = 2,
}
